module.exports = __webpack_public_path__ + "img/13.fb7f98e3.jpg";